module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Edycja notowania")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.record.card.slug
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(!_vm.record.product.archived) ? _c('question-button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "question": "Czy na pewno zarchiwizować produkt?"
    },
    on: {
      "click": function($event) {
        _vm.archiveProduct(_vm.record.product)
      }
    }
  }, [_c('trash-icon'), _vm._v("\n            Archiwizuj produkt\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.record.product.archived) ? _c('question-button', {
    staticClass: "btn btn-warning pull-right",
    attrs: {
      "question": "Czy na pewno przywrócić produkt?"
    },
    on: {
      "click": function($event) {
        _vm.unArchiveProduct(_vm.record.product)
      }
    }
  }, [_c('trash-icon'), _vm._v("\n            Przywróć produkt\n          ")], 1) : _vm._e()], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dane ogólne")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('form-group', {
    attrs: {
      "label": "Nazwa",
      "error": _vm.errors['product.name']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.record.product.name),
      callback: function($$v) {
        _vm.record.product.name = $$v
      },
      expression: "record.product.name"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Odmiana"
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.record.product.variety),
      callback: function($$v) {
        _vm.record.product.variety = $$v
      },
      expression: "record.product.variety"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "offset-col": 2
    }
  }, [_c('checkbox-input', {
    attrs: {
      "label": "Dostępność"
    },
    model: {
      value: (_vm.record.product.enabled),
      callback: function($$v) {
        _vm.record.product.enabled = $$v
      },
      expression: "record.product.enabled"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('form-group', {
    attrs: {
      "label": "Pochodzenie",
      "error": _vm.errors['product.origin']
    }
  }, [_c('select-input', {
    attrs: {
      "options": _vm.originOptions
    },
    model: {
      value: (_vm.record.product.origin),
      callback: function($$v) {
        _vm.record.product.origin = $$v
      },
      expression: "record.product.origin"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Jednostka",
      "error": _vm.errors['product.unit']
    }
  }, [_c('text-input', {
    model: {
      value: (_vm.record.product.unit),
      callback: function($$v) {
        _vm.record.product.unit = $$v
      },
      expression: "record.product.unit"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', [_c('legend', [_vm._v("Aktualne ceny (opublikowane)")]), _vm._v(" "), _vm._l((_vm.record.publicPrices), function(price, index) {
    return _c('form-group', {
      key: index
    }, [_c('currency-input', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    })], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', [_c('legend', [_vm._v("Aktualizacja cen (ceny do publkacji)")]), _vm._v(" "), _vm._l((_vm.record.draftPrices), function(price, index) {
    return _c('form-group', {
      key: index
    }, [_c('currency-input', {
      attrs: {
        "focused": _vm.isDraftPriceFocused(index)
      },
      nativeOn: {
        "keydown": [function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "plus")) { return null; }
          $event.preventDefault();
          _vm.addDraftPrice($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "minus")) { return null; }
          $event.preventDefault();
          _vm.removeFocusedDraftPrice($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
          $event.preventDefault();
          _vm.focusPreviousDraftPrice($event)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
          $event.preventDefault();
          _vm.focusNextDraftPrice($event)
        }],
        "focus": function($event) {
          _vm.updateFocusedDraftPrice(index)
        }
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.removeDraftPrice(index)
        }
      },
      slot: "addon"
    }, [_c('minus-icon')], 1)], 1)
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDraftPrice
    }
  }, [_c('plus-icon'), _vm._v("\n            Dodaj cenę\n          ")], 1)], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', [_c('legend', [_vm._v("Ceny z poprzedniego notowania")]), _vm._v(" "), _vm._l((_vm.record.previousPrices), function(price, index) {
    return _c('form-group', {
      key: index
    }, [_c('currency-input', {
      attrs: {
        "disabled": ""
      },
      model: {
        value: (price.price),
        callback: function($$v) {
          price.price = $$v
        },
        expression: "price.price"
      }
    })], 1)
  }), _vm._v(" "), (_vm.emptyPreviousPrices) ? _c('p', [_vm._v("Brak cen z poprzedniego notowania")]) : _c('div', [_c('question-button', {
    staticClass: "btn btn-default",
    attrs: {
      "question": "Czy na pewno użyć cen z wczoraj?"
    },
    on: {
      "click": _vm.usePreviousPrices
    }
  }, [_c('arrow-left-icon'), _vm._v("\n              Użyj dzisiaj\n            ")], 1)], 1)], 2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('submit-button', {
    attrs: {
      "submitting": _vm.submitting
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d66f7aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecordEdit.vue
// module id = 438
// module chunks = 1